package dev.jfronny.zerointerest.db

import androidx.room3.InvalidationTracker
import androidx.room3.RoomOpenDelegate
import androidx.room3.migration.AutoMigrationSpec
import androidx.room3.migration.Migration
import androidx.room3.util.TableInfo
import androidx.room3.util.TableInfo.Companion.read
import androidx.room3.util.dropFtsSyncTriggers
import androidx.room3.util.performClear
import androidx.sqlite.SQLiteConnection
import androidx.sqlite.execSQL
import kotlin.Lazy
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kotlin.collections.Map
import kotlin.collections.MutableList
import kotlin.collections.MutableMap
import kotlin.collections.MutableSet
import kotlin.collections.Set
import kotlin.collections.mutableListOf
import kotlin.collections.mutableMapOf
import kotlin.collections.mutableSetOf
import kotlin.reflect.KClass

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class ZeroInterestRoomDatabase_Impl : ZeroInterestRoomDatabase() {
  private val _summaryTrustDao: Lazy<SummaryTrustDao> = lazy {
    SummaryTrustDao_Impl(this)
  }

  private val _summaryHeadDao: Lazy<SummaryHeadDao> = lazy {
    SummaryHeadDao_Impl(this)
  }

  private val _summaryDao: Lazy<SummaryDao> = lazy {
    SummaryDao_Impl(this)
  }

  private val _transactionTemplateDao: Lazy<TransactionTemplateDao> = lazy {
    TransactionTemplateDao_Impl(this)
  }

  protected override fun createOpenDelegate(): RoomOpenDelegate {
    val _openDelegate: RoomOpenDelegate = object : RoomOpenDelegate(4, "81cf49b7174273ff021a49713c4cecfc", "ac1edd8fd5ea8308e9b39b7b25df6695") {
      public override suspend fun createAllTables(connection: SQLiteConnection) {
        connection.execSQL("CREATE TABLE IF NOT EXISTS `SummaryTrustEntity` (`roomId` TEXT NOT NULL, `eventId` TEXT NOT NULL, `state` TEXT NOT NULL, PRIMARY KEY(`roomId`, `eventId`))")
        connection.execSQL("CREATE TABLE IF NOT EXISTS `SummaryHeadEntity` (`roomId` TEXT NOT NULL, `eventId` TEXT NOT NULL, PRIMARY KEY(`roomId`, `eventId`))")
        connection.execSQL("CREATE TABLE IF NOT EXISTS `SummaryEntity` (`roomId` TEXT NOT NULL, `summaryId` TEXT NOT NULL, `parentId` TEXT NOT NULL, PRIMARY KEY(`roomId`, `summaryId`, `parentId`))")
        connection.execSQL("CREATE TABLE IF NOT EXISTS `SummaryTransactionEntity` (`roomId` TEXT NOT NULL, `summaryId` TEXT NOT NULL, `transactionId` TEXT NOT NULL, PRIMARY KEY(`roomId`, `summaryId`, `transactionId`))")
        connection.execSQL("CREATE TABLE IF NOT EXISTS `TransactionTemplateEntity` (`roomId` TEXT NOT NULL, `id` TEXT NOT NULL, `description` TEXT NOT NULL, `sender` TEXT NOT NULL, `receivers` TEXT NOT NULL, PRIMARY KEY(`roomId`, `id`))")
        connection.execSQL("CREATE TABLE IF NOT EXISTS room_master_table (id INTEGER PRIMARY KEY,identity_hash TEXT)")
        connection.execSQL("INSERT OR REPLACE INTO room_master_table (id,identity_hash) VALUES(42, '81cf49b7174273ff021a49713c4cecfc')")
      }

      public override suspend fun dropAllTables(connection: SQLiteConnection) {
        connection.execSQL("DROP TABLE IF EXISTS `SummaryTrustEntity`")
        connection.execSQL("DROP TABLE IF EXISTS `SummaryHeadEntity`")
        connection.execSQL("DROP TABLE IF EXISTS `SummaryEntity`")
        connection.execSQL("DROP TABLE IF EXISTS `SummaryTransactionEntity`")
        connection.execSQL("DROP TABLE IF EXISTS `TransactionTemplateEntity`")
      }

      public override suspend fun onCreate(connection: SQLiteConnection) {
      }

      public override suspend fun onOpen(connection: SQLiteConnection) {
        internalInitInvalidationTracker(connection)
      }

      public override suspend fun onPreMigrate(connection: SQLiteConnection) {
        dropFtsSyncTriggers(connection)
      }

      public override suspend fun onPostMigrate(connection: SQLiteConnection) {
      }

      public override suspend fun onValidateSchema(connection: SQLiteConnection): RoomOpenDelegate.ValidationResult {
        val _columnsSummaryTrustEntity: MutableMap<String, TableInfo.Column> = mutableMapOf()
        _columnsSummaryTrustEntity.put("roomId", TableInfo.Column("roomId", "TEXT", true, 1, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsSummaryTrustEntity.put("eventId", TableInfo.Column("eventId", "TEXT", true, 2, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsSummaryTrustEntity.put("state", TableInfo.Column("state", "TEXT", true, 0, null, TableInfo.CREATED_FROM_ENTITY))
        val _foreignKeysSummaryTrustEntity: MutableSet<TableInfo.ForeignKey> = mutableSetOf()
        val _indicesSummaryTrustEntity: MutableSet<TableInfo.Index> = mutableSetOf()
        val _infoSummaryTrustEntity: TableInfo = TableInfo("SummaryTrustEntity", _columnsSummaryTrustEntity, _foreignKeysSummaryTrustEntity, _indicesSummaryTrustEntity)
        val _existingSummaryTrustEntity: TableInfo = read(connection, "SummaryTrustEntity")
        if (!_infoSummaryTrustEntity.equals(_existingSummaryTrustEntity)) {
          return RoomOpenDelegate.ValidationResult(false, """
              |SummaryTrustEntity(dev.jfronny.zerointerest.db.SummaryTrustEntity).
              | Expected:
              |""".trimMargin() + _infoSummaryTrustEntity + """
              |
              | Found:
              |""".trimMargin() + _existingSummaryTrustEntity)
        }
        val _columnsSummaryHeadEntity: MutableMap<String, TableInfo.Column> = mutableMapOf()
        _columnsSummaryHeadEntity.put("roomId", TableInfo.Column("roomId", "TEXT", true, 1, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsSummaryHeadEntity.put("eventId", TableInfo.Column("eventId", "TEXT", true, 2, null, TableInfo.CREATED_FROM_ENTITY))
        val _foreignKeysSummaryHeadEntity: MutableSet<TableInfo.ForeignKey> = mutableSetOf()
        val _indicesSummaryHeadEntity: MutableSet<TableInfo.Index> = mutableSetOf()
        val _infoSummaryHeadEntity: TableInfo = TableInfo("SummaryHeadEntity", _columnsSummaryHeadEntity, _foreignKeysSummaryHeadEntity, _indicesSummaryHeadEntity)
        val _existingSummaryHeadEntity: TableInfo = read(connection, "SummaryHeadEntity")
        if (!_infoSummaryHeadEntity.equals(_existingSummaryHeadEntity)) {
          return RoomOpenDelegate.ValidationResult(false, """
              |SummaryHeadEntity(dev.jfronny.zerointerest.db.SummaryHeadEntity).
              | Expected:
              |""".trimMargin() + _infoSummaryHeadEntity + """
              |
              | Found:
              |""".trimMargin() + _existingSummaryHeadEntity)
        }
        val _columnsSummaryEntity: MutableMap<String, TableInfo.Column> = mutableMapOf()
        _columnsSummaryEntity.put("roomId", TableInfo.Column("roomId", "TEXT", true, 1, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsSummaryEntity.put("summaryId", TableInfo.Column("summaryId", "TEXT", true, 2, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsSummaryEntity.put("parentId", TableInfo.Column("parentId", "TEXT", true, 3, null, TableInfo.CREATED_FROM_ENTITY))
        val _foreignKeysSummaryEntity: MutableSet<TableInfo.ForeignKey> = mutableSetOf()
        val _indicesSummaryEntity: MutableSet<TableInfo.Index> = mutableSetOf()
        val _infoSummaryEntity: TableInfo = TableInfo("SummaryEntity", _columnsSummaryEntity, _foreignKeysSummaryEntity, _indicesSummaryEntity)
        val _existingSummaryEntity: TableInfo = read(connection, "SummaryEntity")
        if (!_infoSummaryEntity.equals(_existingSummaryEntity)) {
          return RoomOpenDelegate.ValidationResult(false, """
              |SummaryEntity(dev.jfronny.zerointerest.db.SummaryEntity).
              | Expected:
              |""".trimMargin() + _infoSummaryEntity + """
              |
              | Found:
              |""".trimMargin() + _existingSummaryEntity)
        }
        val _columnsSummaryTransactionEntity: MutableMap<String, TableInfo.Column> = mutableMapOf()
        _columnsSummaryTransactionEntity.put("roomId", TableInfo.Column("roomId", "TEXT", true, 1, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsSummaryTransactionEntity.put("summaryId", TableInfo.Column("summaryId", "TEXT", true, 2, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsSummaryTransactionEntity.put("transactionId", TableInfo.Column("transactionId", "TEXT", true, 3, null, TableInfo.CREATED_FROM_ENTITY))
        val _foreignKeysSummaryTransactionEntity: MutableSet<TableInfo.ForeignKey> = mutableSetOf()
        val _indicesSummaryTransactionEntity: MutableSet<TableInfo.Index> = mutableSetOf()
        val _infoSummaryTransactionEntity: TableInfo = TableInfo("SummaryTransactionEntity", _columnsSummaryTransactionEntity, _foreignKeysSummaryTransactionEntity, _indicesSummaryTransactionEntity)
        val _existingSummaryTransactionEntity: TableInfo = read(connection, "SummaryTransactionEntity")
        if (!_infoSummaryTransactionEntity.equals(_existingSummaryTransactionEntity)) {
          return RoomOpenDelegate.ValidationResult(false, """
              |SummaryTransactionEntity(dev.jfronny.zerointerest.db.SummaryTransactionEntity).
              | Expected:
              |""".trimMargin() + _infoSummaryTransactionEntity + """
              |
              | Found:
              |""".trimMargin() + _existingSummaryTransactionEntity)
        }
        val _columnsTransactionTemplateEntity: MutableMap<String, TableInfo.Column> = mutableMapOf()
        _columnsTransactionTemplateEntity.put("roomId", TableInfo.Column("roomId", "TEXT", true, 1, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsTransactionTemplateEntity.put("id", TableInfo.Column("id", "TEXT", true, 2, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsTransactionTemplateEntity.put("description", TableInfo.Column("description", "TEXT", true, 0, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsTransactionTemplateEntity.put("sender", TableInfo.Column("sender", "TEXT", true, 0, null, TableInfo.CREATED_FROM_ENTITY))
        _columnsTransactionTemplateEntity.put("receivers", TableInfo.Column("receivers", "TEXT", true, 0, null, TableInfo.CREATED_FROM_ENTITY))
        val _foreignKeysTransactionTemplateEntity: MutableSet<TableInfo.ForeignKey> = mutableSetOf()
        val _indicesTransactionTemplateEntity: MutableSet<TableInfo.Index> = mutableSetOf()
        val _infoTransactionTemplateEntity: TableInfo = TableInfo("TransactionTemplateEntity", _columnsTransactionTemplateEntity, _foreignKeysTransactionTemplateEntity, _indicesTransactionTemplateEntity)
        val _existingTransactionTemplateEntity: TableInfo = read(connection, "TransactionTemplateEntity")
        if (!_infoTransactionTemplateEntity.equals(_existingTransactionTemplateEntity)) {
          return RoomOpenDelegate.ValidationResult(false, """
              |TransactionTemplateEntity(dev.jfronny.zerointerest.db.TransactionTemplateEntity).
              | Expected:
              |""".trimMargin() + _infoTransactionTemplateEntity + """
              |
              | Found:
              |""".trimMargin() + _existingTransactionTemplateEntity)
        }
        return RoomOpenDelegate.ValidationResult(true, null)
      }
    }
    return _openDelegate
  }

  protected override fun createInvalidationTracker(): InvalidationTracker {
    val _shadowTablesMap: MutableMap<String, String> = mutableMapOf()
    val _viewTables: MutableMap<String, Set<String>> = mutableMapOf()
    return InvalidationTracker(this, _shadowTablesMap, _viewTables, "SummaryTrustEntity", "SummaryHeadEntity", "SummaryEntity", "SummaryTransactionEntity", "TransactionTemplateEntity")
  }

  public override suspend fun clearAllTables() {
    performClear(this, false, "SummaryTrustEntity", "SummaryHeadEntity", "SummaryEntity", "SummaryTransactionEntity", "TransactionTemplateEntity")
  }

  protected override fun getRequiredColumnTypeConverterClasses(): Map<KClass<*>, List<KClass<*>>> {
    val _columnTypeConvertersMap: MutableMap<KClass<*>, List<KClass<*>>> = mutableMapOf()
    _columnTypeConvertersMap.put(SummaryTrustDao::class, SummaryTrustDao_Impl.getRequiredColumnConverters())
    _columnTypeConvertersMap.put(SummaryHeadDao::class, SummaryHeadDao_Impl.getRequiredColumnConverters())
    _columnTypeConvertersMap.put(SummaryDao::class, SummaryDao_Impl.getRequiredColumnConverters())
    _columnTypeConvertersMap.put(TransactionTemplateDao::class, TransactionTemplateDao_Impl.getRequiredColumnConverters())
    return _columnTypeConvertersMap
  }

  protected override fun getRequiredDaoReturnTypeConverterClasses(): Map<KClass<*>, List<KClass<*>>> {
    val _daoReturnTypeConvertersMap: MutableMap<KClass<*>, List<KClass<*>>> = mutableMapOf()
    _daoReturnTypeConvertersMap.put(SummaryTrustDao::class, SummaryTrustDao_Impl.getRequiredDaoReturnTypeConverters())
    _daoReturnTypeConvertersMap.put(SummaryHeadDao::class, SummaryHeadDao_Impl.getRequiredDaoReturnTypeConverters())
    _daoReturnTypeConvertersMap.put(SummaryDao::class, SummaryDao_Impl.getRequiredDaoReturnTypeConverters())
    _daoReturnTypeConvertersMap.put(TransactionTemplateDao::class, TransactionTemplateDao_Impl.getRequiredDaoReturnTypeConverters())
    return _daoReturnTypeConvertersMap
  }

  public override fun getRequiredAutoMigrationSpecClasses(): Set<KClass<out AutoMigrationSpec>> {
    val _autoMigrationSpecsSet: MutableSet<KClass<out AutoMigrationSpec>> = mutableSetOf()
    return _autoMigrationSpecsSet
  }

  public override fun createAutoMigrations(autoMigrationSpecs: Map<KClass<out AutoMigrationSpec>, AutoMigrationSpec>): List<Migration> {
    val _autoMigrations: MutableList<Migration> = mutableListOf()
    return _autoMigrations
  }

  public override fun summaryTrustDao(): SummaryTrustDao = _summaryTrustDao.value

  public override fun summaryHeadDao(): SummaryHeadDao = _summaryHeadDao.value

  public override fun summaryDao(): SummaryDao = _summaryDao.value

  public override fun transactionTemplateDao(): TransactionTemplateDao = _transactionTemplateDao.value
}
